var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10938 1.51553C8.1875 1.1796 7.97656 0.843659 7.64062 0.765534C7.30469 0.687409 6.96875 0.898346 6.89062 1.23428L5.99219 5.12491H1.875C1.53125 5.12491 1.25 5.40616 1.25 5.74991C1.25 6.09366 1.53125 6.37491 1.875 6.37491H5.70312L4.26172 12.6249H0.625C0.28125 12.6249 0 12.9062 0 13.2499C0 13.5937 0.28125 13.8749 0.625 13.8749H3.97266L3.14062 17.4843C3.0625 17.8202 3.27344 18.1562 3.60938 18.2343C3.94531 18.3124 4.28125 18.1015 4.35938 17.7655L5.25781 13.8749H10.2227L9.39062 17.4843C9.3125 17.8202 9.52344 18.1562 9.85938 18.2343C10.1953 18.3124 10.5312 18.1015 10.6094 17.7655L11.5078 13.8749H15.625C15.9688 13.8749 16.25 13.5937 16.25 13.2499C16.25 12.9062 15.9688 12.6249 15.625 12.6249H11.7969L13.2383 6.37491H16.875C17.2188 6.37491 17.5 6.09366 17.5 5.74991C17.5 5.40616 17.2188 5.12491 16.875 5.12491H13.5273L14.3594 1.51553C14.4375 1.1796 14.2266 0.843659 13.8906 0.765534C13.5547 0.687409 13.2188 0.898346 13.1406 1.23428L12.2422 5.12491H7.27734L8.10938 1.51553ZM6.98828 6.37491H11.9531L10.5117 12.6249H5.54688L6.98828 6.37491Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.8c80eef883662f8be9fd526c52ef2b8d.svg";
export { ForwardRef as ReactComponent };